
export const indiaStateOptions = [
      // Note: Do not delete or change the 'id' field as it is used to store the unique identifier in the database records.

  { id: 1, label: 'Andhra Pradesh', value: 'Andhra Pradesh', stateCode: 'AP', gstCode: '37' },
  { id: 2, label: 'Arunachal Pradesh', value: 'Arunachal Pradesh', stateCode: 'AR', gstCode: '12' },
  { id: 3, label: 'Assam', value: 'Assam', stateCode: 'AS', gstCode: '18' },
  { id: 4, label: 'Bihar', value: 'Bihar', stateCode: 'BR', gstCode: '10' },
  { id: 5, label: 'Chhattisgarh', value: 'Chhattisgarh', stateCode: 'CG', gstCode: '22' },
  { id: 6, label: 'Goa', value: 'Goa', stateCode: 'GA', gstCode: '30' },
  { id: 7, label: 'Gujarat', value: 'Gujarat', stateCode: 'GJ', gstCode: '24' },
  { id: 8, label: 'Haryana', value: 'Haryana', stateCode: 'HR', gstCode: '06' },
  { id: 9, label: 'Himachal Pradesh', value: 'Himachal Pradesh', stateCode: 'HP', gstCode: '02' },
  { id: 10, label: 'Jharkhand', value: 'Jharkhand', stateCode: 'JH', gstCode: '20' },
  { id: 11, label: 'Karnataka', value: 'Karnataka', stateCode: 'KA', gstCode: '29' },
  { id: 12, label: 'Kerala', value: 'Kerala', stateCode: 'KL', gstCode: '32' },
  { id: 13, label: 'Madhya Pradesh', value: 'Madhya Pradesh', stateCode: 'MP', gstCode: '23' },
  { id: 14, label: 'Maharashtra', value: 'Maharashtra', stateCode: 'MH', gstCode: '27' },
  { id: 15, label: 'Manipur', value: 'Manipur', stateCode: 'MN', gstCode: '14' },
  { id: 16, label: 'Meghalaya', value: 'Meghalaya', stateCode: 'ML', gstCode: '15' },
  { id: 17, label: 'Mizoram', value: 'Mizoram', stateCode: 'MZ', gstCode: '15' },
  { id: 18, label: 'Nagaland', value: 'Nagaland', stateCode: 'NL', gstCode: '13' },
  { id: 19, label: 'Odisha', value: 'Odisha', stateCode: 'OR', gstCode: '21' },
  { id: 20, label: 'Punjab', value: 'Punjab', stateCode: 'PB', gstCode: '03' },
  { id: 21, label: 'Rajasthan', value: 'Rajasthan', stateCode: 'RJ', gstCode: '08' },
  { id: 22, label: 'Sikkim', value: 'Sikkim', stateCode: 'SK', gstCode: '11' },
  { id: 23, label: 'Tamil Nadu', value: 'Tamil Nadu', stateCode: 'TN', gstCode: '33' },
  { id: 24, label: 'Telangana', value: 'Telangana', stateCode: 'TG', gstCode: '36' },
  { id: 25, label: 'Tripura', value: 'Tripura', stateCode: 'TR', gstCode: '16' },
  { id: 26, label: 'Uttar Pradesh', value: 'Uttar Pradesh', stateCode: 'UP', gstCode: '09' },
  { id: 27, label: 'Uttarakhand', value: 'Uttarakhand', stateCode: 'UT', gstCode: '05' },
  { id: 28, label: 'West Bengal', value: 'West Bengal', stateCode: 'WB', gstCode: '19' },
  { id: 29, label: 'Delhi', value: 'Delhi', stateCode: 'DL', gstCode: '07' },
  { id: 30, label: 'Puducherry', value: 'Puducherry', stateCode: 'PY', gstCode: '34' },
  { id: 31, label: 'Dadra and Nagar Haveli and Daman and Diu', value: 'Dadra and Nagar Haveli and Daman and Diu', stateCode: 'DN', gstCode: '25' },
  { id: 32, label: 'Lakshadweep', value: 'Lakshadweep', stateCode: 'LD', gstCode: '31' },
  { id: 33, label: 'Andaman and Nicobar Islands', value: 'Andaman and Nicobar Islands', stateCode: 'AN', gstCode: '35' },
  { id: 34, label: 'Other Territory', value: 'Other Territory', stateCode: 'OT', gstCode: '' },
];

export const findStateByGstCode = (gstCode) => {
  return indiaStateOptions.find(state => state.gstCode === gstCode);
};
export const salutation = [
      // Note: Do not delete or change the 'id' field as it is used to store the unique identifier in the database records.
    {id:1,label:'Mr.',value:"Mr."},
    {id:2,label:'Mrs.',value:"Mrs."},
    {id:3,label:'Ms.',value:"Ms."},
    {id:4,label:'Miss.',value:"Miss."},
    {id:5,label:'Dr.',value:"Dr."},
  ]

  export const GstTreatment = [
        // Note: Do not delete or change the 'id' field as it is used to store the unique identifier in the database records.
    {id:1,label:'Registered Business - Regular',value:"Registered Business - Regular"},
    {id:2,label:'Registered Business - Composition',value:"Registered Business - Composition"},
    {id:3,label:'Unregistered Business',value:"Unregistered Business"},
    {id:4,label:'Consumer',value:"Consumer"},
    {id:5,label:'Special Economic Zone',value:"Special Economic Zone"},
    {id:6,label: 'Deemed Export', value: "Deemed Export", helper: "Departments of the State/Central government, governmental agencies or local authorities" },
    {id:7,label: 'Tax Deductor', value: "Tax Deductor", helper: "A tax deductor is a person or entity that deducts tax at source." },
    {id:8,label: 'SEZ Developer', value: "SEZ Developer", helper: "A person/organisation who owns at least 26% of the equity in creating business units in a Special Economic Zone (SEZ)" },

  ]

  export const accountTypeOptions = [
        // Note: Do not delete or change the 'id' field as it is used to store the unique identifier in the database records.
    { id:0,value: '', label: 'Select Account Type' },
    { id:1,value: 'Savings', label: 'Savings' },
    { id:2,value: 'Current', label: 'Current' },
    { id:3,value: 'Fixed', label: 'Fixed Deposit' },
    { id:4,value: 'Rsecurring', label: 'Recurring Deposit' },
  ];

  export const getAccountType = (id)=>{
    if(id){
      const obj = accountTypeOptions.find(item => item.id === id) || {};
      return obj?.value;
    }
    else return ""
  }

  export const getGstTreatment = (id)=>{
    if(id){
      const obj = GstTreatment.find(item => item.id === id) || {};
      return obj?.value;
    }
    else return ""
  }